
import { MaybeComputedElementRef, unrefElement } from '@vueuse/core';
import { computed, onBeforeUnmount, ref, watch } from '@vue/composition-api';
import { IntentType } from '../dataType';
import PinyinMatch from 'pinyin-match';

const escapeRegexpString = (value = '') => String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');

export type AssociationTrigger = string | string[] | ((firstChar: string, text: string) => boolean);
export type AssociationHandler = (text: string, isSearch:boolean) => void;
export const useInputAssociation = (inputEl: MaybeComputedElementRef<HTMLInputElement>, isAssociation: AssociationTrigger, handler: AssociationHandler) => {
  const target = computed(() => unrefElement(inputEl));
  // 是否联想
  const associateVisible = ref<boolean>(false);
  // 联想选中的值
  const associateValue = ref<IntentType>(undefined);

  // 参数归一化
  const doIsAssociation = (firstChar: string, rangeText: string) => {
    if (typeof isAssociation === 'function') {
      return isAssociation(firstChar, rangeText);
    }
    if (typeof isAssociation === 'string') {
      return firstChar === isAssociation;
    }
    if (Array.isArray(isAssociation)) {
      for (const prefix of isAssociation) {
        if (firstChar === prefix) {
          return true;
        }
      }
    }
    return false;
  };
  const doHandler = () => {
    const text = (target.value!.firstChild as HTMLInputElement)?.value || '';
    const cursorPosition = (target.value!.firstChild as HTMLInputElement)?.selectionStart || 0;
    const rangeText = text.slice(0, cursorPosition);
    // 无意图 取第一个字符 ， 有意图 取到光标的rangeText
    const firstChar = text[0] || '';
    const isTrigger = doIsAssociation(firstChar, rangeText);
    // 没有联想 关闭浮层
    if (!isTrigger) {
      setAssociateState(false);
      return;
    }

    handler(rangeText, true);
  };

  const setAssociateState = (state:boolean):void => {
    associateVisible.value = state;
  };

  watch(target, (el) => {
    if (!el) {
      return;
    }
    el.addEventListener('input', doHandler);
  });
  onBeforeUnmount(() => {
    if (target.value) {
      target.value.removeEventListener('input', doHandler);
    }
  });

  return {
    associateVisible,
    associateValue,
    setAssociateState,
    choose: (text: string) => {
      const el = target.value?.firstChild as HTMLInputElement;
      if (!el) {
        return;
      }
      const cursorPosition = el.selectionStart || 0;
      // 第一个到空格的字符串
      const rangeText = el.value.slice(0, cursorPosition);
      // 首个到光标的文字如果匹配上替换文本  则舍弃原来光标前文本
      const matchText = rangeText.slice(0, 1) === '/' ? rangeText.slice(1) : rangeText;
      const reg = new RegExp(escapeRegexpString(matchText), 'i');
      const isMatch = reg.test(text) || Boolean(PinyinMatch.match(text, matchText));
      const newText = isMatch ? text + el.value.slice(cursorPosition) : text + rangeText + el.value.slice(cursorPosition) ;

      // 移除事件监听器
      el.removeEventListener('input', doHandler);

      el.value = newText;
      // 位置+替换的字符串长度+一个空格
      el.selectionStart = el.selectionEnd = isMatch ? text.length : cursorPosition + text.length + 1;
      el.dispatchEvent(new Event('input'));

      // 重新添加事件监听器
      el.addEventListener('input', doHandler);

      setAssociateState(false);
    }
  };
};